import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterBar = ({ filters, onFilterChange, onClearFilters, resultCount }) => {
  const projectTypeOptions = [
    { value: 'all', label: 'All Project Types' },
    { value: 'residential', label: 'Residential' },
    { value: 'commercial', label: 'Commercial' },
    { value: 'industrial', label: 'Industrial' },
    { value: 'mixed-use', label: 'Mixed Use' }
  ];

  const budgetRangeOptions = [
    { value: 'all', label: 'All Budgets' },
    { value: '0-50', label: '₹0 - ₹50L' },
    { value: '50-100', label: '₹50L - ₹1Cr' },
    { value: '100-500', label: '₹1Cr - ₹5Cr' },
    { value: '500+', label: '₹5Cr+' }
  ];

  const serviceCategoryOptions = [
    { value: 'all', label: 'All Services' },
    { value: 'approvals', label: 'Approvals & Permits' },
    { value: 'construction', label: 'Construction Management' },
    { value: 'consulting', label: 'Technical Consulting' },
    { value: 'legal', label: 'Legal & Documentation' }
  ];

  const sortOptions = [
    { value: 'recent', label: 'Most Recent' },
    { value: 'savings', label: 'Highest Savings' },
    { value: 'timeline', label: 'Fastest Completion' },
    { value: 'rating', label: 'Highest Rated' }
  ];

  return (
    <div className="bg-card rounded-lg construction-shadow p-6 mb-8">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-headline font-bold text-xl text-card-foreground">
            Filter Success Stories
          </h2>
          <p className="text-muted-foreground text-sm mt-1">
            Showing {resultCount} transformation stories
          </p>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onClearFilters}
          className="text-muted-foreground hover:text-primary"
        >
          Clear All
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        <Select
          label="Project Type"
          options={projectTypeOptions}
          value={filters.projectType}
          onChange={(value) => onFilterChange('projectType', value)}
          className="w-full"
        />

        <Select
          label="Budget Range"
          options={budgetRangeOptions}
          value={filters.budgetRange}
          onChange={(value) => onFilterChange('budgetRange', value)}
          className="w-full"
        />

        <Select
          label="Service Category"
          options={serviceCategoryOptions}
          value={filters.serviceCategory}
          onChange={(value) => onFilterChange('serviceCategory', value)}
          className="w-full"
        />

        <Select
          label="Sort By"
          options={sortOptions}
          value={filters.sortBy}
          onChange={(value) => onFilterChange('sortBy', value)}
          className="w-full"
        />

        <div className="flex items-end">
          <Button
            variant="default"
            fullWidth
            iconName="Search"
            iconPosition="left"
            className="h-10"
          >
            Apply Filters
          </Button>
        </div>
      </div>

      {/* Active Filters */}
      {(filters.projectType !== 'all' || filters.budgetRange !== 'all' || filters.serviceCategory !== 'all') && (
        <div className="flex flex-wrap gap-2 mt-4 pt-4 border-t border-border">
          <span className="text-sm text-muted-foreground">Active filters:</span>
          
          {filters.projectType !== 'all' && (
            <div className="flex items-center space-x-1 px-3 py-1 bg-primary/10 text-primary rounded-full text-sm">
              <span>{projectTypeOptions.find(opt => opt.value === filters.projectType)?.label}</span>
              <button
                onClick={() => onFilterChange('projectType', 'all')}
                className="hover:bg-primary/20 rounded-full p-0.5"
              >
                <Icon name="X" size={12} />
              </button>
            </div>
          )}

          {filters.budgetRange !== 'all' && (
            <div className="flex items-center space-x-1 px-3 py-1 bg-secondary/10 text-secondary rounded-full text-sm">
              <span>{budgetRangeOptions.find(opt => opt.value === filters.budgetRange)?.label}</span>
              <button
                onClick={() => onFilterChange('budgetRange', 'all')}
                className="hover:bg-secondary/20 rounded-full p-0.5"
              >
                <Icon name="X" size={12} />
              </button>
            </div>
          )}

          {filters.serviceCategory !== 'all' && (
            <div className="flex items-center space-x-1 px-3 py-1 bg-accent/10 text-accent rounded-full text-sm">
              <span>{serviceCategoryOptions.find(opt => opt.value === filters.serviceCategory)?.label}</span>
              <button
                onClick={() => onFilterChange('serviceCategory', 'all')}
                className="hover:bg-accent/20 rounded-full p-0.5"
              >
                <Icon name="X" size={12} />
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FilterBar;